<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  <!-- Toolbar -->
  <medsurf-toolbar class="mb-2"></medsurf-toolbar>
  <!-- Content -->
  @if (slideAuthorFacade.chapterPanelData$ | async; as chapterPanelData) {
    <p-splitter
      class="flex flex-1 overflow-hidden justify-content-center h-full mb-2"
      styleClass="w-full"
      panelStyleClass="min-w-4_5rem"
      [gutterSize]="FlatModels.PanelDesignModels.panelGutterSizeBig"
      [panelSizes]="chapterPanelData.panelSize"
      [minSizes]="[FlatModels.PanelDesignModels.panelMinSizeBig, FlatModels.PanelDesignModels.panelMinSizeMain]"
      layout="horizontal"
      (onResizeStart)="chapterOnResizeStart()"
      (onResizeEnd)="chapterOnResizeEnd($event)">
      <ng-template pTemplate>
        <medsurf-design-content-collapsible-panel
          titleText="global.contents"
          id="node_tree_mainmenu_panel"
          class="w-full"
          [isMinimized]="chapterPanelData.isMinimized"
          menuName="node_tree_menu"
          [menuItems]="(contentsMenuItems$ | async) || []"
          (collapsedChange)="chapterCollapsedChange($event)">
          <div #node_tree_scroll_panel
               class="flex flex-1 overflow-auto justify-content-center align-self-center max-h-sidebar">
            <medsurf-node-tree class="w-full h-full mb-2"
            [hidden]="chapterPanelData.isMinimized"></medsurf-node-tree>
          </div>
        </medsurf-design-content-collapsible-panel>
      </ng-template>
      <ng-template pTemplate>
        @if ({node: (slideAuthorFacade.currentSelectedNode$ | async)}; as data) {
          <medsurf-chapter-main 
            [blockUi]="[{
              blocked: (appSharedFacade.canWriteNode$(data.node?.id) | async) === false }
            ]"
            class="flex flex-1 w-full surface-600 medsurf-white">
          </medsurf-chapter-main>
        }
      </ng-template>
    </p-splitter>
  }
</div>
